/** Where a document came from, in the four words of the Source column - ADR-0212 decision 10.
 *
 * **Derived on read from the server's `source` and stored nowhere**: how a document arrived is a
 * fact the row already carries (`document.source`), and a second copy of it would be one more thing
 * to disagree. `Manual` is not a document origin (a manual figure has no document) and is therefore
 * never returned here; it is the figures' word.
 *
 * `email` and `vendor_portal` are documents somebody sent in, which the person-facing word for is
 * *Uploaded*; neither route exists in the product today (`OtherWays` says so), so the mapping is
 * written for the day they do and costs nothing before it.
 */

import type { Origin } from "../components/ui/SourceChip";

const BY_SOURCE: Readonly<Record<string, Origin>> = {
  upload: "uploaded",
  email: "uploaded",
  vendor_portal: "uploaded",
  import: "imported",
  connector: "connector",
};

/** The origin of a document row, or `uploaded` for a source this table has never heard of: every
 * document the product holds was handed to it, and an unlisted route is still that. */
export function originOfDocument(source: string): Origin {
  return BY_SOURCE[source] ?? "uploaded";
}
